import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { includes, filter } from 'lodash';
import SearchProductListModal from '../../../../views/widget/common/modal/SearchProductListModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { appActions } from '../../../../store/modules/app';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

class SearchProductModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedProductList: [],
      /**
       *  선택된 상품 ID
       */
      selectedProductIdList: props.data.selectedId ? [props.data.selectedId] : [],
    };
  }

  componentDidMount = () => {
    this.initiate(this.props.data.selectedId);
  };

  componentDidUpdate(prevProps) {
    if (comparePrePropsAndNextProps([[prevProps.data.selectedItem, this.props.data.selectedItem]])) {
      this.setState({
        selectedProductList: [this.props.data.selectedItem],
      });
    }
  }

  initiate = (productId) => {
    this.getList({
      productId,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 상품 선택하기
   */
  onSubmit = () => {
    const { selectedProductList, selectedProductIdList } = this.state;
    const { setData, data } = this.props;
    const { targetPath } = data;

    const selectedProduct = selectedProductList[0];
    const selectedProductId = selectedProductIdList[0];

    /**
     *  상품이 선택되었는지 체크
     */
    if (!selectedProductId) {
      message.error('상품을 선택해주세요.');
      return;
    }

    setData({
      path: [...targetPath, 'linkId'],
      value: selectedProductId,
    });

    /**
     *  선택된 상품명 가져오기
     */
    const productName = selectedProduct.productName;

    setData({
      path: [...targetPath, 'linkName'],
      value: productName,
    });

    setData({
      path: [...targetPath, 'productId'],
      value: selectedProductId,
    });
    setData({
      path: [...targetPath, 'productName'],
      value: productName,
    });
    setData({
      path: [...targetPath, 'salesPrice'],
      value: selectedProduct.salesPrice,
    });
    setData({
      path: [...targetPath, 'originPrice'],
      value: selectedProduct.originPrice,
    });
    setData({
      path: [...targetPath, 'discountRate'],
      value: selectedProduct.discountRate,
    });
    setData({
      path: [...targetPath, 'storeName'],
      value: selectedProduct.brandName,
    });

    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchProductListModal', value: false });
  };

  /**
   * 상품 리스트 가져오기
   */
  getList = (option) => {
    const { getProductList, data } = this.props;
    const { listPath, listData } = data;
    const { filterOption, sortOption, pagination } = listData;

    getProductList({
      filterOption,
      sortOption,
      pagination,
      ...option,
      listPath,
    });
  };

  /**
   * 상품 선택 callback
   */
  onCheckProduct = (list) => {
    const { selectedProductIdList } = this.state;
    const { data } = this.props;
    let targetIdList = list;

    if (list.length > 1) {
      targetIdList = filter(list, (id) => id !== selectedProductIdList[0]);
    }

    const targetList = filter(data.listData.list, (item) => includes(targetIdList, item.id));

    this.setState({
      selectedProductList: targetList,
      selectedProductIdList: targetIdList,
    });
  };

  render() {
    return (
      <SearchProductListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
        getProductList={this.getList}
        onCheckProduct={this.onCheckProduct}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchProductListModal.isOpen,
    data: state.widget.searchProductListModal.data,
    mainProductCategorySelectList: state.widget.widgetSave.mainProductCategorySelectList,
    subProductCategorySelectList: state.widget.widgetSave.subProductCategorySelectList,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
  setData: widgetActions.setData,
  getProductList: widgetActions.getProductList,
  openImgViewModal: appActions.openImgViewModal,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchProductModalContainer));
